export const HERE_API_KEY = `Ep0qx935SzOqIxGBkmWAejvgCC0iWoEaM1GM2JDnEbs`
export const LOSS_RATIO_TARGET = 55
export const LOSS_RATIO_TARGET_V2 = 50
export const fleetSafetyThreshold = {
  low: 80,
  medium: 60,
  high: 40,
  severe: 0,
}
